<template>
    <div :style="closeStyle" class="widget-close">
        <button
            class="widget-close-button"
            style="
                padding: 0;
                height: 22px;
                width: 22px;
                border-radius: 4px;
                transition: 0.2s;
                display: flex;
                align-items: center;
                justify-content: center;
                background: transparent;
                outline: none;
                border: none;
                cursor: pointer;
            "
            @click="$emit('close')"
        >
            <svg
                data-v-67484a78=""
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                stroke="#3E4755"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M20 10L9.99994 20M9.99997 10L20 20"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                ></path>
            </svg>
        </button>
        <component is="style">
            {{ inlineStyle }}
        </component>
    </div>
</template>

<script>
export default {
    name: "WidgetClose",
    computed: {
        inlineStyle() {
            return `
                .widget-close-button:hover {
                    box-shadow: 0 2px 5px rgba(128, 158, 191, 0.25);
                    background-color: #fff;
                }
            `
        },
        closeStyle() {
            return {
                display: "flex",
                justifyContent: "flex-end",
                pointerEvents: window.builder_dev_mode ? "none" : "all",
                zIndex: 555,
                width: "100%",
                paddingRight: "5px"
            }
        }
    }
}
</script>
